/**
 * WEB-1620 — предел адресатов в одном запросе приглашений по почте.
 *
 * ИСТОЧНИК ПРАВДЫ — БЭКЕНД: `MAX_INVITE_RECIPIENTS_PER_REQUEST` в
 * `backend/src/shared/constants/invite-email-limits.ts`, откуда его берёт
 * `@ArrayMaxSize(...)` в `backend/src/projects/dto/project.dto.ts`
 * (`SendInviteEmailsDto.recipients`). Число здесь — вторая копия, и она
 * вынужденная: фронт обязан знать предел ДО отправки (иначе человек получает
 * «Bad Request» без объяснения), а сгенерированные типы
 * (`src/api/generated/schema.ts`) числовых ограничений не переносят —
 * openapi-typescript выкидывает `maxItems` из схемы.
 *
 * Копия не остаётся без присмотра: рядом стоит сторож паритета
 * `inviteLimits.parity.test.ts` — он читает файл бэка и краснеет при любом
 * расхождении. Меняя число тут, поменяйте его на бэке (или наоборот) — иначе
 * сторож не пропустит.
 */
export const MAX_INVITE_RECIPIENTS_PER_REQUEST = 20;
